<template>
  <div class="product-price-page row-block" :style="{ minHeight: minHeight }">
    <div class="filter-container" :style="{ width: '250px' }">
      <productPriceFilter
        :minHeight="minHeight"
        :disabled="false"
        :title="'農產品零售價格分析'"
        :filters="{
          init: init.filters,
          options: filterOptions
        }"
        @changeFilters="c => { conditions.filters = c; fetchDatas() }"
        @updateList="() => update = update + 1"
      ></productPriceFilter>
    </div>
    <div class="panel-container" :style="{ flex: 1 }">
      <div v-if="onSearch" class="mask center-block">
        <!-- <img :src="require('../../assets/images/loading.gif')"> -->
        <img :src="require('../../assets/images/upload.svg')" alt="">
      </div>
      <productPricePanel
        :minHeight="minHeight"
        :datas="datas"
        :filterOptions="{
          filters: filterOptions
        }"
        :conditions="conditions"
        :update="update"
        @changeState="s => tabState = s"
      ></productPricePanel>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getProductPriceGraphProducts, getProductPriceResults } from '../../api'
import productPriceFilter from '../../components/productPrice/filter'
import productPricePanel from '../../components/productPrice/panel'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'

export default {
  components: {
    productPriceFilter,
    productPricePanel
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      datas: [],
      products: [],
      init: {
        filters: {
          kind: '',
          crop_name: ''
        }
      },
      conditions: {
        filters: {}
      },
      onSearch: false,
      tabState: 'table',
      update: 0
    }
  },
  computed: {
    // static
    kindOptions () {
      return [
        { title: '蔬菜', value: 'vegetable' },
        { title: '水果', value: 'fruit' }
      ]
    },
    productOptions () {
      return this.products.map(product => ({
        title: product.name,
        value: product.name,
        kind: product.kind
      }))
    },
    filterOptions () {
      return [
        {
          title: '產品類別',
          value: 'kind',
          type: 'select',
          options: this.kindOptions,
          placeholder: () => '水果、蔬菜...'
        },
        {
          title: '作物(產品)',
          value: 'crop_name',
          type: 'select',
          options: this.productOptions,
          optionDisplay: result => option => option.kind === result.kind,
          placeholder: () => '請選擇產品'
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'setModalAction'
    ]),
    async fetchData () {
      await this.fetchProducts()
      // await this.fetchDatas()
    },
    async fetchProducts () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getProductPriceGraphProducts(config)
        let products = response.data.data
        this.products = products
      } catch (error) {
        throw error
      }
    },
    async fetchDatas () {
      this.onSearch = true
      try {
        let config = this.$ls.get('userInfo')
        let conditions = this.conditions.filters
        let response = await getProductPriceResults(conditions, config)
        let datas = response.data.data
        this.datas = datas
      } catch (error) {
        this.datas = []
        if (error.response.status === 429) {
          this.addToast('error', '您的操作過於頻繁，請稍後再繼續。')
        }
      }
      this.onSearch = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/productPrice.vue